module.exports = function getResource(label, vars = []) {
    const resources = {
        myGallery: 'My Gallery Activity',
        myPhotos: 'My Photos',
        noPhotos: 'You don’t have any photos yet.',
        uploadAPhoto: 'Upload a photo or video to get started.',
        addAPhoto: 'Add a Photo',
        myLovedPhotos: 'My Loved Photos',
        noLovedPhotos: 'You haven’t loved any photos yet.',
        collectYourPhotos: 'Collect your favorite photos by clicking on the',
        exploreTheGallery: 'Explore the Gallery'
    };
    return resources[label];
};
